import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import Loading from "../../hoc/Loading/Loading";
import Select from "react-select";
import axios from "../../axios";
import * as actionCreators from "../../modules/actions/index";
import { connect } from "react-redux";
import * as url from "../../utils/url";
import {
  whiteLabelStyling,
  isUserRemoved,
  groupContentFields,
  create_user_edit_obj,
  groupPrivacyStatusDesc,
  genderMapOptions,
  profilePicValidityCheck,
  stripHtmlTags,
  checkValidationOfModule,
} from "../../utils/constants";
import { toolkitCategories } from "../../utils/categories";
import moment from "moment";
import rightArrowImg from "../../assets/right-arrow.svg";
import {
  Table,
  Modal,
  ModalBody,
  Button,
  ListGroupItem,
  Col,
  Row,
  Input,
  ModalHeader,
  Progress,
  DropdownMenu,
  DropdownToggle,
  Dropdown,
  Alert,
  Label,
} from "reactstrap";
import "./ProfilePage.css";
import { isMobile } from "../../utils/deviceInfo";
import UserIcon3 from "../../assets/user-image-plc/User_Icon_3.svg";
// import Maps from '../../components/Geolocate/Maps'
import TooltipDefinition from "../../components/UI/TooltipDefinition/TooltipDefinition";
import LoginInfo from "./UserProfile/LoginInfo/LoginInfo";
import UserRobot1 from "../../assets/user-image-plc/User_Robot_1.svg";
import DatePicker from "react-datepicker";
import CKEditorUI from "../../components/CKEditor/CKEditorUI";
import Toggle from "react-toggle";
import { FaRegComments } from "react-icons/fa";
import { MdOutlineGroups3 } from "react-icons/md";
import { HiOutlineChartSquareBar } from "react-icons/hi";
import { MdOutlinePendingActions } from "react-icons/md";
import { GrResources } from "react-icons/gr";

const diversity_array = [
  "dIRole",
  "gender",
  "ethnicity",
  "sexualOrientation",
  "religion",
  "veteran",
  "disability",
];

class ProfileAbout extends Component {
  constructor(props) {
    super(props);

    let currentUser = this.props.currentUser;
    this.state = {
      menu: null,
      description:
        currentUser && currentUser.description ? currentUser.description : "",
      sanitized_description:
        currentUser && currentUser.sanitized_description
          ? currentUser.sanitized_description
          : "",
      currentUser,
      isGeoInput: false,
      geolocate: {},
      showEditProfileInfoModal: false,
      firstName: {
        value: currentUser.firstName || "",
        updatedValue: currentUser.firstName || "",
        error: false,
      },
      lastName: {
        value: currentUser.lastName || "",
        updatedValue: currentUser.lastName || "",
        error: false,
      },
      title: {
        value: currentUser.title || "",
        updatedValue: currentUser.title || "",
        error: false,
      },
      dIRole: {
        value: currentUser.dIRole || "",
        updatedValue: currentUser.dIRole || "",
      },
      gender: {
        value:
          currentUser.gender && currentUser.gender.reference
            ? currentUser.gender.reference
            : null,
        options: genderMapOptions.filter((e) => e.label !== "All"),
        updatedValue:
          currentUser.gender && currentUser.gender.reference
            ? currentUser.gender.reference
            : null,
      },
      ethnicity: {
        value:
          currentUser.ethnicity && currentUser.ethnicity.reference
            ? currentUser.ethnicity.reference
            : null,
        options: [],
        updatedValue:
          currentUser.ethnicity && currentUser.ethnicity.reference
            ? currentUser.ethnicity.reference
            : null,
      },
      occupation: {
        value:
          currentUser.occupation && currentUser.occupation.reference
            ? currentUser.occupation.reference
            : null,
        options: [],
        updatedValue:
          currentUser.occupation && currentUser.occupation.reference
            ? currentUser.occupation.reference
            : null,
      },
      seniority: {
        value:
          currentUser.seniority && currentUser.seniority.reference
            ? currentUser.seniority.reference
            : null,
        options: [],
        updatedValue:
          currentUser.seniority && currentUser.seniority.reference
            ? currentUser.seniority.reference
            : null,
      },
      sexualOrientation: {
        value:
          currentUser.sexualOrientation &&
            currentUser.sexualOrientation.reference
            ? currentUser.sexualOrientation.reference
            : null,
        options: [],
        updatedValue:
          currentUser.sexualOrientation &&
            currentUser.sexualOrientation.reference
            ? currentUser.sexualOrientation.reference
            : null,
      },
      veteran: {
        value:
          currentUser.veteran && currentUser.veteran.reference
            ? currentUser.veteran.reference
            : null,
        options: [],
        updatedValue:
          currentUser.veteran && currentUser.veteran.reference
            ? currentUser.veteran.reference
            : null,
      },
      disability: {
        value:
          currentUser.disability && currentUser.disability.reference
            ? currentUser.disability.reference
            : null,
        options: [],
        updatedValue:
          currentUser.disability && currentUser.disability.reference
            ? currentUser.disability.reference
            : null,
      },
      religion: {
        value:
          currentUser.religion && currentUser.religion.reference
            ? currentUser.religion.reference
            : null,
        options: [],
        updatedValue:
          currentUser.religion && currentUser.religion.reference
            ? currentUser.religion.reference
            : null,
      },
      birthDate: {
        value: currentUser.birthDate ? currentUser.birthDate : null,
        updatedValue: currentUser.birthDate ? currentUser.birthDate : null,
      },
      profilePic: {
        value: profilePicValidityCheck(currentUser.profilePic)
          ? currentUser.profilePic
          : null,
        updatedValue: profilePicValidityCheck(currentUser.profilePic)
          ? currentUser.profilePic
          : null,
        error: false,
      },
      profileBgImg: {
        value: currentUser.profileBgImg || undefined,
        updatedValue: currentUser.profileBgImg || undefined,
        error: false,
      },
      updatedFields: [],
    };
    this.timer = null;
  }

  componentDidMount() {
    let religion = [],
      sexualOrientation = [],
      veteran = [],
      disability = [],
      ethnicity = [],
      seniority = [],
      occupation = [];
    axios.get(url.getDiversityTypes).then(({ data }) => {
      let resp = data.data;
      resp.map((e) => {
        if (e.categoryGrouping === "VETERAN") {
          veteran.push({
            value: e._id,
            label: e.name,
            definition: e.definition,
          });
        } else if (e.categoryGrouping === "SEXUAL ORIENTATION") {
          sexualOrientation.push({
            value: e._id,
            label: e.name,
            definition: e.definition,
          });
        } else if (e.categoryGrouping === "DISABILITY") {
          disability.push({
            value: e._id,
            label: e.name,
            definition: e.definition,
          });
        } else if (e.categoryGrouping === "RELIGION") {
          religion.push({
            value: e._id,
            label: e.name,
            definition: e.definition,
          });
        } else if (e.categoryGrouping === "ETHNICITY") {
          ethnicity.push({
            value: e._id,
            label: e.name,
            definition: e.definition,
          });
        } else if (e.categoryGrouping === "SENIORITY") {
          if (e.name != "All") {
            seniority.push({
              value: e._id,
              label: e.name,
              definition: e.definition,
            });
          }
        } else if (e.categoryGrouping === "OCCUPATION") {
          if (e.name != "All") {
            occupation.push({
              value: e._id,
              label: e.name,
              definition: e.definition,
            });
          }
        }
      });
      this.setState((prevState) => ({
        ethnicity: { ...prevState.ethnicity, options: ethnicity },
        religion: { ...prevState.religion, options: religion },
        veteran: { ...prevState.veteran, options: veteran },
        disability: { ...prevState.disability, options: disability },
        sexualOrientation: {
          ...prevState.sexualOrientation,
          options: sexualOrientation,
        },
        occupation: { ...prevState.occupation, options: occupation },
        seniority: { ...prevState.seniority, options: seniority },
      }));
    });
  }

  showLabel = (div, memberDiv) => {
    // console.log('div---', div)
    if (div.options && div.options.length > 0) {
      if (div.updatedValue) {
        let obj = div.options.filter((e) => {
          if (e.value === div.updatedValue) {
            return {
              value: e.value,
              label: e.label,
            };
          }
        });
        return obj && obj[0] ? obj[0].label : null
      } else {
        return "N/A";
      }
    }
  };

  diversityCheck = (diversity) => {
    if (diversity && diversity.reference) {
      return diversity.reference;
    } else {
      return null;
    }
  };

  showGenderLabel = (gender) => {
    if (gender.options) {
      let val = gender.updatedValue;
      let res = gender.options.filter((e) => {
        if (e.value === val) {
          return {
            value: e.value,
            label: e.label,
          };
        }
      });
      return res[0];
    }
  };

  grabLabel = (div) => {
    if (div && div.updatedValue) {
      let val = div.updatedValue;
      let obj = div.options.filter((e) => {
        if (e.value === val) {
          return {
            value: e.value,
            label: e.label,
          };
        }
      });
      return obj[0];
    } else {
      return null;
    }
  };

  diversityValue = (div, userDiv) => {
    // console.log(div, userDiv)
    if (div.options) {
      if (div.updatedValue && (div.updatedValue.value || div.updatedValue)) {
        let val = div.updatedValue ? div.updatedValue : div.updatedValue.value;
        let obj = div.options.filter((e) => {
          if (e.value === val) {
            return {
              value: e.value,
              label: e.label,
            };
          }
        });
        return obj[0];
      } else if (userDiv && userDiv.reference) {
        let obj = div.options.filter((e) => {
          if (e.value === userDiv.reference) {
            return { value: e.value, label: e.label };
          }
        });

        return obj[0];
      }
    } else {
      return null;
    }
  };

  updateDiversity = (value, obj) => {
    if (value && value.value) {
      obj["updatedValue"] = value.value;
      this.setState({ obj });
    } else {
      obj["updatedValue"] = null;
      this.setState({ obj });
    }
  };

  showLabel = (div, userDiv) => {
    // console.log('div---', div)
    if (div.options && div.options.length > 0) {
      if (div.updatedValue) {
        let obj = div.options.filter((e) => {
          if (e.value === div.updatedValue) {
            return {
              value: e.value,
              label: e.label,
            };
          }
        });
        return obj && obj[0] ? obj[0].label : null
      } else {
        return "N/A";
      }
    }
  };

  getInitials = (user) => {
    let firstName =
      user.firstName && user.firstName.length > 0 ? user.firstName : "N";
    let lastName =
      user.lastName && user.lastName.length > 0 ? user.lastName : "N";
    return firstName.charAt(0).toUpperCase() + lastName.charAt(0).toUpperCase();
  };

  handleEditProfileInfo = () => {
    let specialChar = /[~`!#$%\^&*+=\\[\]\\';,/{}|\\":<>\?0-9]/g;

    let {
      firstName,
      lastName,
      title,
      dIRole,
      profilePic,
      birthDate,
      gender,
      occupation,
      seniority,
      ethnicity,
      religion,
      sexualOrientation,
      disability,
      veteran,
    } = { ...this.state };
    if (
      firstName.updatedValue.trim() === "" ||
      specialChar.test(firstName.updatedValue)
    ) {
      this.setState({
        firstName: {
          updatedValue: firstName.updatedValue,
          value: firstName.value,
          error: true,
          errorMessage: "Please remove any numbers or special characters.",
        },
      });
    } else if (
      lastName.updatedValue.trim() === "" ||
      specialChar.test(lastName.updatedValue)
    ) {
      this.setState({
        lastName: {
          updatedValue: lastName.updatedValue,
          value: lastName.value,
          error: true,
          errorMessage: "Please remove any numbers or special characters.",
        },
      });
    } else if (title.updatedValue.trim() === "") {
      this.setState({
        title: {
          updatedValue: "",
          value: title.value,
          error: true,
          errorMessage: "Please enter your title.",
        },
      });
    } else {
      let formData = new FormData();
      formData.append("firstName", firstName.updatedValue);
      formData.append("lastName", lastName.updatedValue);
      formData.append("ethnicity", JSON.stringify(this.grabLabel(ethnicity)));
      formData.append("religion", JSON.stringify(this.grabLabel(religion)));
      formData.append(
        "sexualOrientation",
        JSON.stringify(this.grabLabel(sexualOrientation))
      );
      formData.append("disability", JSON.stringify(this.grabLabel(disability)));
      formData.append("seniority", JSON.stringify(this.grabLabel(seniority)));
      formData.append("occupation", JSON.stringify(this.grabLabel(occupation)));
      formData.append("veteran", JSON.stringify(this.grabLabel(veteran)));
      formData.append("gender", JSON.stringify(this.grabLabel(gender)));
      formData.append("title", title.updatedValue);
      formData.append("dIRole", dIRole.updatedValue);
      formData.append("birthDate", birthDate.updatedValue);
      formData.append("profilePic", profilePic.updatedValue);
      axios
        .put(url.editProfileInfo, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          let {
            firstName,
            lastName,
            title,
            dIRole,
            profilePic,
            gender,
            ethnicity,
            religion,
            veteran,
            sexualOrientation,
            occupation,
            seniority,
            disability,
            birthDate,
          } = response.data.data;
          this.props.profileEditSuccsess({
            firstName,
            lastName,
            title,
            dIRole,
            profilePic,
            ethnicity,
            gender,
            religion,
            veteran,
            occupation,
            seniority,
            disability,
            sexualOrientation,
            birthDate,
          });
          this.setState((prevState) => ({
            showEditProfileInfoModal: false,
            firstName: { value: firstName, updatedValue: firstName },
            lastName: { value: lastName, updatedValue: lastName },
            title: { value: title, updatedValue: title },
            dIRole: { value: dIRole, updatedValue: dIRole },
            profilePic: { value: profilePic, updatedValue: profilePic },
            gender: {
              ...prevState.gender,
              updatedValue: this.diversityCheck(gender),
              value: this.diversityCheck(gender),
            },
            ethnicity: {
              ...prevState.ethnicity,
              updatedValue: this.diversityCheck(ethnicity),
              value: this.diversityCheck(ethnicity),
            },
            religion: {
              ...prevState.religion,
              updatedValue: this.diversityCheck(religion),
              value: this.diversityCheck(religion),
            },
            veteran: {
              ...prevState.veteran,
              updatedValue: this.diversityCheck(veteran),
              value: this.diversityCheck(veteran),
            },
            disability: {
              ...prevState.disability,
              updatedValue: this.diversityCheck(disability),
              value: this.diversityCheck(disability),
            },
            sexualOrientation: {
              ...prevState.sexualOrientation,
              updatedValue: this.diversityCheck(sexualOrientation),
              value: this.diversityCheck(sexualOrientation),
            },
            occupation: {
              ...prevState.occupation,
              updatedValue: this.diversityCheck(occupation),
              value: this.diversityCheck(occupation),
            },
            seniority: {
              ...prevState.seniority,
              updatedValue: this.diversityCheck(seniority),
              value: this.diversityCheck(seniority),
            },
            birthDate: {
              ...prevState.birthDate,
              updatedValue: birthDate,
              value: birthDate,
            },
          }));
        })
        .catch((error) => {
          console.log(error);
          if (error)
            this.setState({
              error: true,
              errorMessage: error.response.data,
              // .errors.messages
            });
        });
    }
  };

  updateUser = () => {
    let { description } = this.state,
      that = this;

    let { payload, formData } = create_user_edit_obj(this.state);

    formData.append("payload", JSON.stringify(payload));

    axios
      .put(url.editProfileInfo, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        that.props.onProfileUpdate(response.data.data);
        that.setState({
          updatedFields: [],
          description,
        });
        // let {firstName, lastName, title, dIRole, profilePic,gender, description,
        //   ethnicity, religion, veteran, sexualOrientation,occupation, seniority, disability, birthDate } = response.data.data;
        // that.props.profileEditSuccsess({
        //           firstName,lastName,title,dIRole,profilePic,ethnicity, gender,description,
        //           religion, veteran, occupation, seniority,disability, sexualOrientation, birthDate
        //         });
        // that.setState(prevState => ({showEditProfileInfoModal: false,
        //   updatedFields:[],
        //   description,
        //   firstName: {value: firstName, updatedValue: firstName},
        // }))
      })
      .catch((error) => {
        console.log(error);

        let err_res =
          error && error.response && error.response.data
            ? error.response.data
            : error.response
              ? error.response
              : error;
        if (err_res) {
          this.setState({ error: true, errorMessage: err_res });
        }
      });
  };

  openProfileDetailsModal = () => {
    this.setState({ showEditProfileInfoModal: true });
  };

  closeProfileModal = () => {
    this.setState((state) => ({
      showEditProfileInfoModal: !state.showEditProfileInfoModal,
      firstName: {
        value: state.firstName.value,
        updatedValue: state.firstName.value,
      },
      lastName: {
        value: state.lastName.value,
        updatedValue: state.lastName.value,
      },
      title: { value: state.title.value, updatedValue: state.title.value },
      dIRole: { value: state.dIRole.value, updatedValue: state.dIRole.value },
      profilePic: {
        value: state.profilePic.value,
        updatedValue: state.profilePic.value,
      },
    }));
  };

  handleProfilePicUpload = (event) => {
    let profilePic = event.target.files[0];
    let profilePicExt = profilePic.name.split(".")[
      profilePic.name.split(".").length - 1
    ];
    let profilePicUrl = URL.createObjectURL(event.target.files[0]);
    if (!["png", "jpg", "jpeg"].includes(profilePicExt.toLowerCase())) {
      this.setState({
        profilePicUrl: undefined,
        profilePic: {
          value: this.props.user.profilePic,
          error: true,
          errorMessage: "Only .png and .jpg files are allowed.",
        },
      });
    } else if (profilePic.size > 1024 * 1024 * 2) {
      this.setState({
        profilePicUrl: undefined,
        profilePic: {
          value: this.props.user.profilePic,
          error: true,
          errorMessage: "Image size is more that 2MB",
        },
      });
    } else {
      this.setState({
        profilePic: {
          updatedValue: profilePic,
          value: this.props.user.profilePic,
          profilePicUrl: profilePicUrl,
          error: false,
          errorMessage: "",
        },
      });
    }
  };

  editTask = (field, isUndo) => {
    let { updatedFields } = this.state;
    if (updatedFields.indexOf(field) == -1) {
      updatedFields.push(field);
      this.setState({ updatedFields });
    } else {
      let result = updatedFields.filter((e) => e != field);
      this.setState({ updatedFields: result });
    }
  };

  handleChangeTaskDescription = (event) => {
    const descriptionContext = event.editor.getData();

    this.setState({
      description: descriptionContext,
      sanitized_description: stripHtmlTags(descriptionContext),
    });
  };

  checkUserPermission = (field) => {
    // let ownerFields = ['title', 'archive','dueDate', 'assignedTo','restore']
    // let currentUser = this.props.user.profile
    let { currentUser } = this.state;
    if (currentUser._id == this.props.user.profile._id) {
      return true;
    }
    return false;
  };

  createMarkup = (input) => {
    return { __html: `<div>${input}</div>` };
  };

  updateNotificationPreference = (module, value) => {
    const prefs = { ...this.state.currentUser.notificationPreferences };

    let that = this;

    if (prefs[module]) {
      prefs[module].isDisabled = !value;
      prefs[module].date = new Date();
    }

    axios
      .post(url.updateNotificationPrefs, {
        userId: this.state.currentUser._id,
        data: prefs,
      })
      .then(({ data }) => {
        if (data.data) {
          that.props.profileEditSuccsess(prefs);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  renderProfile = () => {
    // let{member:user}=this.props
    let {
      firstName,
      lastName,
      title,
      dIRole,
      isOpenGeo,
      addressTxt,
      profileBgImg,
      currentUser,
      menu,
      updatedFields,
      showEditProfileInfoModal,
      profilePic,
      gender,
      occupation,
      seniority,
      religion,
      ethnicity,
      sexualOrientation,
      veteran,
      disability,
      birthDate,
      description,
    } = this.state;
    let { member, user } = this.props;

    console.log("is memeber:", member)

    let canEdit =
      user.profile && currentUser && user.profile._id == currentUser._id;

    const { organization } = this.props;
    const { isTrivvyUrl } = this.props;

    return (
      <span>
        {isTrivvyUrl && (
          (member && (
            member._id == this.props.user.profile._id ||
            member._id == this.props.user._id
          )) ||
          (
            (this.props.user && this.props.user.role === "Admin") ||
            (this.props.user &&
              this.props.user.profile &&
              this.props.user.profile.role === "Admin")
          )
        ) &&
          <div
            className={`profile_page_about_container wrap-padding-card ${isMobile ? "ml-3" : "ml50"
              }`}
          >
            <div className="">
              <div className={`row ${isMobile ? "mt-0" : ""}`}>
                <Col sm={2} className={`${isMobile ? "col-5" : "text-right"}`}>
                  <span className="profile-label">Employee ID:</span>
                </Col>
                <Col
                  sm={9}
                  className={`align-self-center ${isMobile && "col-7"}`}
                >
                  <span className="profile-value">{member && member.employeeId ? member.employeeId : "--"}</span>
                </Col>
              </div>
              <div className={`row ${isMobile ? "mt-0" : ""}`}>
                <Col sm={2} className={`${isMobile ? "col-5" : "text-right"}`}>
                  <span className="profile-label">Email:</span>
                </Col>
                <Col
                  sm={9}
                  className={`align-self-center ${isMobile && "col-7"}`}
                >
                  <span className="profile-value">{member && member.email && !member.isDummyEmail ? member.email : "--"}</span>
                </Col>
              </div>
              <div className={`row ${isMobile ? "mt-0" : ""}`}>
                <Col sm={2} className={`${isMobile ? "col-5" : "text-right"}`}>
                  <span className="profile-label">Mobile Number:</span>
                </Col>
                <Col
                  sm={9}
                  className={`align-self-center ${isMobile && "col-7"}`}
                >
                  <span className="profile-value">{member && member.mobileNumber ? member.mobileNumber : "--"}</span>
                </Col>
              </div>
            </div>
          </div>
        }
        {!isTrivvyUrl &&
          <div
            className={`profile_page_about_container card ${isMobile ? "mt-2" : "mt10"
              }`}
          >
            {canEdit && this.checkUserPermission("description") ? (
              <span
                className="profile_page_login_btn"
                onClick={
                  this.checkUserPermission("description")
                    ? () => this.editTask("description")
                    : null
                }
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  viewBox="0 0 16 16"
                >
                  <path d="M8 4.754a3.246 3.246 0 1 0 0 6.492 3.246 3.246 0 0 0 0-6.492zM5.754 8a2.246 2.246 0 1 1 4.492 0 2.246 2.246 0 0 1-4.492 0z" />
                  <path d="M9.796 1.343c-.527-1.79-3.065-1.79-3.592 0l-.094.319a.873.873 0 0 1-1.255.52l-.292-.16c-1.64-.892-3.433.902-2.54 2.541l.159.292a.873.873 0 0 1-.52 1.255l-.319.094c-1.79.527-1.79 3.065 0 3.592l.319.094a.873.873 0 0 1 .52 1.255l-.16.292c-.892 1.64.901 3.434 2.541 2.54l.292-.159a.873.873 0 0 1 1.255.52l.094.319c.527 1.79 3.065 1.79 3.592 0l.094-.319a.873.873 0 0 1 1.255-.52l.292.16c1.64.893 3.434-.902 2.54-2.541l-.159-.292a.873.873 0 0 1 .52-1.255l.319-.094c1.79-.527 1.79-3.065 0-3.592l-.319-.094a.873.873 0 0 1-.52-1.255l.16-.292c.893-1.64-.902-3.433-2.541-2.54l-.292.159a.873.873 0 0 1-1.255-.52l-.094-.319zm-2.633.283c.246-.835 1.428-.835 1.674 0l.094.319a1.873 1.873 0 0 0 2.693 1.115l.291-.16c.764-.415 1.6.42 1.184 1.185l-.159.292a1.873 1.873 0 0 0 1.116 2.692l.318.094c.835.246.835 1.428 0 1.674l-.319.094a1.873 1.873 0 0 0-1.115 2.693l.16.291c.415.764-.42 1.6-1.185 1.184l-.291-.159a1.873 1.873 0 0 0-2.693 1.116l-.094.318c-.246.835-1.428.835-1.674 0l-.094-.319a1.873 1.873 0 0 0-2.692-1.115l-.292.16c-.764.415-1.6-.42-1.184-1.185l.159-.291A1.873 1.873 0 0 0 1.945 8.93l-.319-.094c-.835-.246-.835-1.428 0-1.674l.319-.094A1.873 1.873 0 0 0 3.06 4.377l-.16-.292c-.415-.764.42-1.6 1.185-1.184l.292.159a1.873 1.873 0 0 0 2.692-1.115l.094-.319z" />
                </svg>
              </span>
            ) : // <i className={'flaticon-edit singleTaskIconClass'}
              // onClick={this.checkUserPermission('description')?()=>this.editTask('description'):null}
              // style={{color: '#777777'}} />
              null}

            <div className="singleTaskDesContainer">
              <div
                className={
                  this.checkUserPermission("description")
                    ? "editableTaskField"
                    : ""
                }
              >
                {this.checkUserPermission("description") ? (
                  <i
                    className={"flaticon-edit singleTaskIconClass"}
                    onClick={
                      this.checkUserPermission("description")
                        ? () => this.editTask("description")
                        : null
                    }
                    style={{ color: "#777777" }}
                  />
                ) : null}
                <span className="singleTaskDesTxt">
                  About
                  {this.checkUserPermission("description") &&
                    updatedFields.indexOf("description") > -1 ? (
                    <span>
                      {/* <i className="flaticon-edit profileIconEditIcon" /> */}
                      <span
                        className="profile_page_description_btn_container_btnSave singleTaskEditBtn btn-succes"
                        onClick={
                          this.checkUserPermission("description")
                            ? () => this.updateUser("description")
                            : null
                        }
                      >
                        Save
                      </span>
                      <span
                        className="profile_page_description_btn_container_btnClose singleTaskEditBtn"
                        onClick={
                          this.checkUserPermission("description")
                            ? () => this.editTask("description")
                            : null
                        }
                      >
                        Close
                      </span>
                    </span>
                  ) : null}
                </span>
              </div>
              {this.checkUserPermission("description") ? (
                updatedFields.indexOf("description") > -1 ? (
                  <span>
                    <p
                      className={
                        this.checkUserPermission("description")
                          ? "card-text editableTaskField"
                          : "card-text "
                      }
                      onClick={
                        this.checkUserPermission("description")
                          ? () => this.editTask("description")
                          : null
                      }
                    />
                    <CKEditorUI
                      onChange={this.handleChangeTaskDescription}
                      value={description}
                      afterPaste={this.addText}
                    />
                  </span>
                ) : description.length > 0 ? (
                  <span
                    className={
                      this.checkUserPermission("description")
                        ? "card-text editableTaskField"
                        : "card-text "
                    }
                    // onClick={this.checkUserPermission('description')?()=>this.editTask('description'):null}
                    dangerouslySetInnerHTML={this.createMarkup(description)}
                  />
                ) : (
                  <span
                    className={
                      this.checkUserPermission("description")
                        ? "card-text editableTaskField"
                        : "card-text "
                    }
                    onClick={
                      this.checkUserPermission("description")
                        ? () => this.editTask("description")
                        : null
                    }
                  >
                    {" "}
                    Click here to add a short, rich, wonderful description about
                    yourself.
                  </span>
                )
              ) : (
                <span className="card-text">No description added.</span>
              )}
              {/* canEdit */}

              {/* {organization && currentUser &&
              currentUser.notificationPreferences &&
              this.checkUserPermission("notificationPreferences") ? (
                <div className="my-3 notification-prefs-container">
                  <i
                    className={"flaticon-edit singleTaskIconClass"}
                    style={{ color: "#777777" }}
                  />
                  <span className="singleTaskDesTxt">
                    Email Notification Preferences
                  </span>

                  <div

                  // style={{marginLeft:"35px"}}
                  >
                    {console.log("currentUser.organizationId",currentUser.organizationId)}
                    {checkValidationOfModule(organization,organization.isCultureApp) &&  currentUser.notificationPreferences.cultureApp ? (
                      <div className="d-flex align-items-center my-3">
                        <Label className="mb-0 w-300px">
                          <FaRegComments className="mr-2" /> Culture App
                        </Label>
                        <Toggle
                          checked={
                            !currentUser.notificationPreferences.cultureApp
                              .isDisabled
                          }
                          icons={false}
                          className="ml-2"
                          onChange={(e) => {
                            this.updateNotificationPreference(
                              "cultureApp",
                              e.target.checked
                            );
                          }}
                        />
                      </div>
                    ) : (
                      ""
                    )}
                    {checkValidationOfModule(organization,organization.isGroups) && currentUser.notificationPreferences.groups ? (
                      <div className="d-flex align-items-center my-3">
                        <Label className="mb-0 w-300px">
                          <MdOutlineGroups3 className="mr-2" />
                          Groups
                        </Label>
                        <Toggle
                          checked={
                            !currentUser.notificationPreferences.groups.isDisabled
                          }
                          icons={false}
                          className="ml-2"
                          onChange={(e) => {
                            this.updateNotificationPreference(
                              "groups",
                              e.target.checked
                            );
                          }}
                        />
                      </div>
                    ) : (
                      ""
                    )}
                    {checkValidationOfModule(organization,organization.isPlanning) &&  currentUser.notificationPreferences.planning ? (
                      <div className="d-flex align-items-center my-3">
                        <Label className="mb-0 w-300px">
                          <MdOutlinePendingActions className="mr-2" />
                          Planning
                        </Label>
                        <Toggle
                          checked={
                            !currentUser.notificationPreferences.planning
                              .isDisabled
                          }
                          icons={false}
                          className="ml-2"
                          onChange={(e) => {
                            this.updateNotificationPreference(
                              "planning",
                              e.target.checked
                            );
                          }}
                        />
                      </div>
                    ) : (
                      ""
                    )}
                    {checkValidationOfModule(organization,organization.isAnalytics) &&  currentUser.notificationPreferences.analytics ? (
                      <div className="d-flex align-items-center my-3">
                        <Label className="mb-0 w-300px">
                          <HiOutlineChartSquareBar className="mr-2" />
                          Analytics
                        </Label>
                        <Toggle
                          checked={
                            !currentUser.notificationPreferences.analytics
                              .isDisabled
                          }
                          icons={false}
                          className="ml-2"
                          onChange={(e) => {
                            this.updateNotificationPreference(
                              "analytics",
                              e.target.checked
                            );
                          }}
                        />
                      </div>
                    ) : (
                      ""
                    )}
                    {checkValidationOfModule(organization,organization.isToolkit) &&  currentUser.notificationPreferences.resources ? (
                      <div className="d-flex align-items-center my-3">
                        <Label className="mb-0 w-300px">
                          <GrResources className="mr-2" />
                          Resources
                        </Label>
                        <Toggle
                          checked={
                            !currentUser.notificationPreferences.resources
                              .isDisabled
                          }
                          icons={false}
                          className="ml-2"
                          onChange={(e) => {
                            this.updateNotificationPreference(
                              "resources",
                              e.target.checked
                            );
                          }}
                        />
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              ) : null} */}
            </div>
          </div>
        }

        {((this.props.user.profile._id == currentUser._id) && !isTrivvyUrl) ? (
          <LoginInfo user={this.props.user.profile} />
        ) : null}

        <Modal isOpen={showEditProfileInfoModal} className="profile-info-modal">
          <ModalHeader
            className="dashboardHeader"
            charCode="X"
            toggle={this.closeProfileModal}
          >
            <div className="dashboardModalTitle">Edit Profile</div>
          </ModalHeader>
          <ModalBody className="profile-modal-body">
            <Row className="mlmr0">
              <Col
                sm={3}
                className="profile-modal-label align-self-center"
              ></Col>
              <Col sm={9}>
                <div className="img-container">
                  {profilePic.profilePicUrl ||
                    profilePic.value ||
                    profilePic ? (
                    <img
                      src={
                        profilePic.profilePicUrl ||
                        profilePic.value ||
                        UserRobot1
                      }
                      className="user-profile-img"
                    />
                  ) : (
                    <span
                      className="profile_modal_change_image"
                      data-letters={this.getInitials(this.props.user.profile)}
                    ></span>
                  )}

                  <div className="middle">
                    <div className="text d-flex align-items-center justify-content-center">
                      <label
                        htmlFor="profile-pic-file-input"
                        style={{ marginBottom: "0px" }}
                      >
                        <span
                          className="cursor-pointer edit-txt "
                          style={{ color: "white" }}
                        >
                          edit
                        </span>
                      </label>
                      <input
                        id="profile-pic-file-input"
                        onChange={this.handleProfilePicUpload}
                        type="file"
                      />
                    </div>
                  </div>
                </div>
                {profilePic.error ? (
                  <div className="input-error-msg-field">
                    {profilePic.errorMessage}
                  </div>
                ) : null}

                <label className="changeProfilePic">
                  Change Profile Picture
                  <input
                    id="profile-pic-file-input"
                    type="file"
                    onChange={this.handleProfilePicUpload}
                  ></input>
                </label>
              </Col>
            </Row>

            <Row className="mlmr0 mt10">
              <Col sm={3} className="profile-modal-label">
                First Name
              </Col>
              <Col sm={9}>
                <Input
                  type="text"
                  className="input-custom"
                  value={firstName.updatedValue}
                  onChange={(event) => {
                    this.setState({
                      firstName: {
                        updatedValue: event.target.value,
                        value: firstName.value,
                      },
                    });
                  }}
                  invalid={firstName.error}
                />
                {firstName.error ? (
                  <div className="input-error-msg-field">
                    {firstName.errorMessage}
                  </div>
                ) : null}
              </Col>
            </Row>
            <Row className="mlmr0 mt10">
              <Col sm={3} className="profile-modal-label">
                Last Name
              </Col>
              <Col sm={9}>
                <Input
                  type="text"
                  className="input-custom"
                  value={lastName.updatedValue}
                  onChange={(event) => {
                    this.setState({
                      lastName: {
                        updatedValue: event.target.value,
                        value: lastName.value,
                      },
                    });
                  }}
                  invalid={lastName.error}
                />
                {lastName.error ? (
                  <div className="input-error-msg-field">
                    {lastName.errorMessage}
                  </div>
                ) : null}
              </Col>
            </Row>
            <Row className="mlmr0 mt10">
              <Col sm={3} className="profile-modal-label">
                Title
              </Col>
              <Col sm={9}>
                <Input
                  type="text"
                  className="input-custom"
                  value={title.updatedValue}
                  onChange={(event) => {
                    this.setState({
                      title: {
                        updatedValue: event.target.value,
                        value: title.value,
                      },
                    });
                  }}
                  invalid={title.error}
                />
                {title.error ? (
                  <div className="input-error-msg-field">
                    {title.errorMessage}
                  </div>
                ) : null}
              </Col>
            </Row>

            <Row className="mlmr0 mt10">
              <Col sm={3} className="profile-modal-label">
                <div className="text-right profile-modal-label">Occupation</div>
                <div className="profile-modal-optional-txt">(optional)</div>
              </Col>
              <Col sm={9}>
                <Select
                  className="map-table-dropdown"
                  placeholder="Select occupation"
                  value={
                    occupation.updatedValue
                      ? this.diversityValue(
                        occupation,
                        this.props.user.occupation,
                        "occupation"
                      )
                      : null
                  }
                  optionRenderer={this.renderFieldOptions}
                  clearable={false}
                  options={occupation.options.sort(function (a, b) {
                    if (a.label < b.label) return -1;
                    else if (a.label > b.label) return 1;
                    return 0;
                  })}
                  valueKey="value"
                  labelKey="label"
                  getOptionLabel={({ label }) => label}
                  getOptionValue={({ value }) => value}
                  onChange={(e) => this.updateDiversity(e, occupation)}
                />
              </Col>
            </Row>

            <Row className="mlmr0 mt10">
              <Col sm={3} className="profile-modal-label">
                <div className="text-right profile-modal-label">
                  Job Category
                </div>
                <div className="profile-modal-optional-txt">(optional)</div>
              </Col>
              <Col sm={9}>
                <Select
                  className="map-table-dropdown"
                  placeholder="Select job category"
                  value={
                    seniority.updatedValue
                      ? this.diversityValue(
                        seniority,
                        this.props.user.seniority,
                        "seniority"
                      )
                      : null
                  }
                  optionRenderer={this.renderFieldOptions}
                  clearable={false}
                  options={seniority.options.sort(function (a, b) {
                    if (a.label < b.label) return -1;
                    else if (a.label > b.label) return 1;
                    return 0;
                  })}
                  valueKey="value"
                  labelKey="label"
                  getOptionLabel={({ label }) => label}
                  getOptionValue={({ value }) => value}
                  onChange={(e) => this.updateDiversity(e, seniority)}
                />
              </Col>
            </Row>
            <Row className="mlmr0 mt10">
              <Col sm={3}>
                <div className="text-right profile-modal-label">DEI Role</div>
                <div className="profile-modal-optional-txt">(optional)</div>
              </Col>
              <Col sm={9}>
                <div className="inner-addon right-addon">
                  <span className="diRole-max-length-hint">
                    {dIRole.updatedValue ? dIRole.updatedValue.length : "0"}/250
                  </span>
                  <Input
                    type="textarea"
                    minLength="0"
                    maxLength="250"
                    className="profile-modal-textarea"
                    value={dIRole.updatedValue}
                    style={{ resize: "none" }}
                    onChange={(event) => {
                      this.setState({
                        dIRole: {
                          updatedValue: event.target.value,
                          value: dIRole.value,
                        },
                      });
                    }}
                  />
                </div>
              </Col>
            </Row>

            <Row className="mlmr0 mt10">
              <Col sm={3} className="profile-modal-label">
                <div className="text-right profile-modal-label">
                  Date of Birth
                </div>
                <div className="profile-modal-optional-txt">(optional)</div>
              </Col>
              <Col sm={9}>
                <div className="inner-addon right-addon">
                  {/* <span className="tool-start-date flaticon-calendar" onClick={() => this.openDatePicker("selectFileDate")} /> */}
                  <DatePicker
                    id="selectFileDate"
                    placeholderText="Enter birth date"
                    className="input-custom-date form-control"
                    showYearDropdown
                    onChange={this.handleDateChange}
                    selected={
                      birthDate.updatedValue
                        ? moment(birthDate.updatedValue)
                        : null
                    }
                    maxDate={moment()}
                  />
                </div>
              </Col>
            </Row>

            <Row className="mlmr0 mt10">
              <Col sm={3} className="profile-modal-label">
                <div className="text-right profile-modal-label">Gender</div>
                <div className="profile-modal-optional-txt">(optional)</div>
              </Col>
              <Col sm={9}>
                <Select
                  className="map-table-dropdown"
                  placeholder="Select gender"
                  // value={this.diversityValue(gender)}
                  value={
                    gender.updatedValue
                      ? this.diversityValue(
                        gender,
                        this.props.user.gender,
                        "gender"
                      )
                      : null
                  }
                  // optionRenderer={this.renderFieldOptions}
                  clearable={false}
                  options={gender.options.sort(function (a, b) {
                    if (a.label < b.label) return -1;
                    else if (a.label > b.label) return 1;
                    return 0;
                  })}
                  valueKey="value"
                  labelKey="label"
                  getOptionLabel={({ label }) => label}
                  getOptionValue={({ value }) => value}
                  onChange={(e) => this.updateDiversity(e, gender)}
                // onChange={(event)=> this.setState({gender: { updatedValue: {value:event.target.value, label:event.target.value}}}) }
                />
              </Col>
            </Row>

            <Row className="mlmr0 mt10">
              <Col sm={3} className="profile-modal-label">
                <div className="text-right profile-modal-label">Ethnicity</div>
                <div className="profile-modal-optional-txt">(optional)</div>
              </Col>
              <Col sm={9}>
                <Select
                  className="map-table-dropdown"
                  placeholder="Select ethnicity"
                  value={
                    ethnicity.updatedValue
                      ? this.diversityValue(
                        ethnicity,
                        this.props.user.ethnicity,
                        "ethnicity"
                      )
                      : null
                  }
                  optionRenderer={this.renderFieldOptions}
                  clearable={false}
                  options={ethnicity.options.sort(function (a, b) {
                    if (a.label < b.label) return -1;
                    else if (a.label > b.label) return 1;
                    return 0;
                  })}
                  getOptionLabel={({ label }) => label}
                  getOptionValue={({ value }) => value}
                  valueKey="value"
                  labelKey="label"
                  onChange={(e) => this.updateDiversity(e, ethnicity)}
                />
              </Col>
            </Row>

            <Row className="mlmr0 mt10">
              <Col sm={3} className="profile-modal-label">
                <div className="text-right profile-modal-label">
                  Sexual Orientation
                </div>
                <div className="profile-modal-optional-txt">(optional)</div>
              </Col>
              <Col sm={9}>
                <Select
                  className="map-table-dropdown"
                  placeholder="Select sexual orientation"
                  value={
                    sexualOrientation.updatedValue
                      ? this.diversityValue(
                        sexualOrientation,
                        this.props.user.sexualOrientation,
                        "sexualOrientation"
                      )
                      : null
                  }
                  optionRenderer={this.renderFieldOptions}
                  clearable={false}
                  options={sexualOrientation.options.sort(function (a, b) {
                    if (a.label < b.label) return -1;
                    else if (a.label > b.label) return 1;
                    return 0;
                  })}
                  getOptionLabel={({ label }) => label}
                  getOptionValue={({ value }) => value}
                  valueKey="value"
                  labelKey="label"
                  onChange={(e) => this.updateDiversity(e, sexualOrientation)}
                />
              </Col>
            </Row>

            <Row className="mlmr0 mt10">
              <Col sm={3} className="profile-modal-label">
                <div className="text-right profile-modal-label">
                  Veteran Status
                </div>
                <div className="profile-modal-optional-txt">(optional)</div>
              </Col>
              <Col sm={9}>
                <Select
                  className="map-table-dropdown"
                  placeholder="Select veteran type"
                  value={
                    veteran.updatedValue
                      ? this.diversityValue(
                        veteran,
                        this.props.user.veteran,
                        "veteran"
                      )
                      : null
                  }
                  optionRenderer={this.renderFieldOptions}
                  clearable={false}
                  options={veteran.options}
                  valueKey="value"
                  labelKey="label"
                  getOptionLabel={({ label }) => label}
                  getOptionValue={({ value }) => value}
                  onChange={(e) => this.updateDiversity(e, veteran)}
                />
              </Col>
            </Row>

            <Row className="mlmr0 mt10">
              <Col sm={3} className="profile-modal-label">
                <div className="text-right profile-modal-label">Disability</div>
                <div className="profile-modal-optional-txt">(optional)</div>
              </Col>
              <Col sm={9}>
                <Select
                  className="map-table-dropdown"
                  placeholder="Select disability type"
                  value={
                    disability.updatedValue
                      ? this.diversityValue(
                        disability,
                        this.props.user.disability,
                        "disability"
                      )
                      : null
                  }
                  optionRenderer={this.renderFieldOptions}
                  clearable={false}
                  options={disability.options.sort(function (a, b) {
                    if (a.label < b.label) return -1;
                    else if (a.label > b.label) return 1;
                    return 0;
                  })}
                  valueKey="value"
                  labelKey="label"
                  getOptionLabel={({ label }) => label}
                  getOptionValue={({ value }) => value}
                  onChange={(e) => this.updateDiversity(e, disability)}
                />
              </Col>
            </Row>

            <Row className="mlmr0 mt10">
              <Col sm={3} className="profile-modal-label">
                <div className="text-right profile-modal-label">Religion</div>
                <div className="profile-modal-optional-txt">(optional)</div>
              </Col>
              <Col sm={9}>
                <Select
                  className="map-table-dropdown"
                  placeholder="Select religion"
                  value={
                    religion.updatedValue
                      ? this.diversityValue(
                        religion,
                        this.props.user.religion,
                        "religion"
                      )
                      : null
                  }
                  optionRenderer={this.renderFieldOptions}
                  clearable={false}
                  options={religion.options.sort(function (a, b) {
                    if (a.label < b.label) return -1;
                    else if (a.label > b.label) return 1;
                    return 0;
                  })}
                  valueKey="value"
                  labelKey="label"
                  getOptionLabel={({ label }) => label}
                  getOptionValue={({ value }) => value}
                  onChange={(e) => this.updateDiversity(e, religion)}
                />
              </Col>
            </Row>

            <Row className={`${isMobile && "mb30"}  mlmr0 mt30`}>
              <Col sm={{ size: 4 }} md={{ size: 4 }}>
                <Button
                  className="profile-modal-save-btn"
                  onClick={this.handleEditProfileInfo}
                >
                  <span className="profile-modal-save-btn-txt">
                    {!isMobile ? "Save" : "Continue"}
                    {!isMobile && <span className="ml10 flaticon-tick"></span>}
                  </span>
                  {isMobile && (
                    <span className="ml10">
                      <img
                        className=""
                        style={{ height: "32px" }}
                        src={rightArrowImg}
                      />
                    </span>
                  )}
                </Button>
              </Col>
              {!isMobile && (
                <Col sm={{ size: 4 }} md={{ size: 4 }}>
                  <Button
                    className="profile-modal-cancel-btn"
                    onClick={() => this.closeProfileModal()}
                  >
                    <span className="profile-modal-cancel-btn-txt">Cancel</span>
                  </Button>
                </Col>
              )}
            </Row>
          </ModalBody>
        </Modal>
      </span>
    );
  };

  render() {
    return this.renderProfile();
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.user,
    kpiMaster: state.kpiMaster,
    mappingMaster: state.mappingMaster,
    reports: state.reports,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onKpiMasterListFetched: (data) =>
      dispatch(actionCreators.storeKpiMaster(data)),
    onMappingMasterListFetched: (data) =>
      dispatch(actionCreators.storeMappingMaster(data)),
    onProfileUpdate: (data) =>
      dispatch(actionCreators.updateProfileInfoSuccess(data)),
    updateNavBar: (header) => dispatch(actionCreators.navBarUpdate(header)),
    updateReport: (dashboard) =>
      dispatch(actionCreators.updateReport(dashboard)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Loading(ProfileAbout, axios)));
